var _path, _path2, _path3, _g, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 641,
    height: 640,
    viewBox: "0 0 641 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M618.971 247.594C612.052 162.281 608.592 119.624 592.488 92.0265C546.378 13.005 412.319 -5.78946 327.65 1.41776C214.298 11.0639 84.6249 76.2258 27.5449 202.037C-24.2988 316.309 -0.393424 445.658 77.7237 530.272C220.925 685.383 516.316 657.689 588.475 555.908C617.272 515.289 619.348 450.41 622.399 355.106C623.865 309.23 621.004 272.671 618.971 247.594Z",
    fill: "url(#paint0_radial_2_2610)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M618.971 247.594C612.052 162.281 608.592 119.624 592.488 92.0265C546.378 13.005 412.319 -5.78946 327.65 1.41776C214.298 11.0639 84.6249 76.2258 27.5449 202.037C-24.2988 316.309 -0.393424 445.658 77.7237 530.272C220.925 685.383 516.316 657.689 588.475 555.908C617.272 515.289 619.348 450.41 622.399 355.106C623.865 309.23 621.004 272.671 618.971 247.594Z",
    fill: "url(#paint1_linear_2_2610)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M564.654 52.1945C557.326 46.1314 546.209 42.8292 536.812 42.1624C470.2 37.4421 460.478 176.679 470.689 207.796C480.899 238.913 474.283 249.13 421.821 265.411C369.358 281.691 394.526 313.036 400.92 331.367C407.315 349.698 419.978 365.184 381.733 383.398C343.489 401.613 356.78 412.898 356.78 412.898C356.78 412.898 427.308 485.041 423.412 461.945C419.516 438.848 426.575 403.972 489.81 401.32C517.047 400.178 558.756 387.187 567.991 358.022C570.142 351.23 571.638 340.858 570.003 333.829C567.733 324.078 561.334 316.396 557.78 307.218C549.5 285.831 570.27 270.17 582.222 255.874C588.464 248.411 594.7 240.758 599.478 232.25C609.4 214.583 605.685 195.638 594.881 179.353C589.699 171.545 582.501 163.26 580.24 153.945C577.813 143.94 579.93 130.271 580.505 119.978C580.957 111.905 581.727 103.865 581.272 95.7713C580.432 80.722 576.906 62.3317 564.654 52.1945Z",
    fill: "url(#paint2_linear_2_2610)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M351.234 453.39C350.777 453.555 350.259 453.361 350.028 452.92C349.777 452.438 349.962 451.842 350.444 451.591C350.741 451.435 380.433 435.817 413.555 410.094C444.076 386.392 483.837 349.02 499.934 305.573C513.38 269.288 525.641 209.301 533.577 140.997C540.693 79.7471 541.817 34.4484 538.793 26.04C538.608 25.5284 538.875 24.9644 539.387 24.7794C539.898 24.5944 540.462 24.8616 540.647 25.3731C544.185 35.2111 541.94 86.0979 535.537 141.225C527.585 209.68 515.283 269.832 501.784 306.259C485.52 350.151 445.471 387.81 414.738 411.672C381.479 437.496 351.656 453.18 351.359 453.335C351.316 453.356 351.275 453.374 351.234 453.39Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M533.47 152.87C532.961 153.053 532.443 152.911 532.255 152.402C532.009 151.728 507.176 84.92 475.155 69.8364C474.661 69.6058 474.463 69.0486 474.693 68.5553C474.926 68.062 475.518 67.8679 476.009 68.0986C508.763 83.527 533.08 148.933 534.101 151.717C534.288 152.229 533.986 152.685 533.475 152.868C533.473 152.87 533.47 152.87 533.47 152.87Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M521.359 230.347C520.98 230.484 520.537 230.377 520.265 230.046C519.92 229.625 519.98 229.004 520.4 228.659C520.583 228.509 538.866 213.512 561.424 200.927C591.903 183.922 615.263 179.175 630.851 186.818C631.34 187.058 631.541 187.647 631.301 188.136C631.061 188.625 630.472 188.825 629.983 188.586C594.116 171.002 522.371 229.584 521.651 230.178C521.562 230.253 521.462 230.31 521.359 230.347Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M441.762 388.713C441.661 388.749 441.556 388.768 441.444 388.77C440.901 388.779 440.453 388.345 440.444 387.799C440.44 387.514 439.933 358.849 433.933 328.646C428.432 300.954 417.073 266.268 394.2 258.275C393.686 258.094 393.414 257.533 393.595 257.021C393.773 256.507 394.337 256.235 394.849 256.416C413.922 263.08 427.722 287.261 435.87 328.29C441.901 358.664 442.408 387.482 442.413 387.77C442.422 388.204 442.148 388.573 441.762 388.713Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M482.464 342.402C482.064 342.546 481.603 342.418 481.338 342.059C481.014 341.621 481.107 341.004 481.543 340.682C484.715 338.337 559.537 283.331 588.716 288.583C589.252 288.679 589.606 289.193 589.51 289.727C589.414 290.264 588.903 290.62 588.366 290.522C560.014 285.418 483.485 341.696 482.715 342.265C482.637 342.327 482.55 342.37 482.464 342.402Z",
    fill: "white"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M623.117 257.275C618.273 249.09 608.929 242.221 600.312 238.414C539.225 211.433 482.964 339.167 482.042 371.903C481.119 404.64 471.436 412.016 416.562 409.584C361.686 407.152 374.762 445.165 374.577 464.579C374.392 483.992 381.067 502.848 338.916 507.048C296.764 511.248 305.451 526.363 305.451 526.363C305.451 526.363 347.409 618.116 351.558 595.062C355.707 572.009 374.15 541.579 434.551 560.483C460.566 568.625 504.211 570.513 522.771 546.194C527.094 540.531 532.01 531.278 532.849 524.109C534.011 514.166 530.59 504.771 530.35 494.933C529.793 472.005 554.639 464.296 570.723 454.889C579.12 449.979 587.579 444.887 594.955 438.497C610.269 425.231 613.185 406.147 608.529 387.167C606.296 378.067 602.324 367.834 603.35 358.304C604.45 348.069 611.068 335.92 615.092 326.429C618.248 318.986 621.694 311.679 624.005 303.91C628.31 289.456 631.217 270.959 623.117 257.275Z",
    fill: "url(#paint3_linear_2_2610)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M286.531 562.586C286.047 562.586 285.624 562.228 285.556 561.734C285.483 561.195 285.86 560.697 286.399 560.624C286.73 560.579 319.955 555.929 359.827 542.931C396.567 530.955 446.629 509.24 476.479 473.804C501.41 444.208 533.246 391.91 563.824 330.32C591.244 275.092 607.629 232.844 607.629 223.908C607.629 223.365 608.07 222.924 608.614 222.924C609.157 222.924 609.598 223.365 609.598 223.908C609.598 234.363 590.267 281.488 565.587 331.197C534.941 392.922 503.01 445.364 477.984 475.074C447.828 510.873 397.398 532.759 360.403 544.815C320.368 557.861 286.997 562.529 286.664 562.575C286.622 562.584 286.577 562.586 286.531 562.586Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M559.708 341.661C559.167 341.661 558.726 341.25 558.724 340.708C558.719 339.991 557.959 268.67 532.93 243.642C532.544 243.258 532.544 242.639 532.93 242.255C533.314 241.872 533.937 241.874 534.323 242.258C559.925 267.86 560.674 337.731 560.695 340.695C560.699 341.238 560.261 341.661 559.715 341.661C559.711 341.661 559.708 341.661 559.708 341.661Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M522.096 410.268C521.692 410.268 521.313 410.017 521.169 409.615C520.986 409.104 521.251 408.54 521.765 408.355C521.987 408.275 544.266 400.348 569.754 396.139C604.189 390.451 627.777 393.89 639.862 406.356C640.241 406.747 640.23 407.37 639.839 407.749C639.449 408.128 638.825 408.117 638.446 407.727C610.645 379.044 523.309 409.894 522.43 410.209C522.318 410.25 522.206 410.268 522.096 410.268Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M393.605 532.358C393.5 532.358 393.393 532.339 393.285 532.305C392.771 532.129 392.495 531.57 392.673 531.054C392.765 530.782 401.988 503.639 406.562 473.186C410.755 445.266 411.803 408.782 392.984 393.52C392.561 393.178 392.497 392.557 392.84 392.134C393.183 391.712 393.804 391.646 394.226 391.99C409.919 404.715 414.724 432.142 408.506 473.503C403.904 504.127 394.63 531.417 394.537 531.691C394.397 532.1 394.014 532.358 393.605 532.358Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M447.575 502.551C447.15 502.551 446.76 502.275 446.632 501.85C446.475 501.33 446.771 500.779 447.292 500.624C451.069 499.491 540.091 473.047 565.771 487.863C566.241 488.135 566.403 488.738 566.131 489.208C565.86 489.678 565.257 489.841 564.786 489.569C539.833 475.173 448.774 502.236 447.858 502.51C447.765 502.538 447.669 502.551 447.575 502.551Z",
    fill: "white"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M418.343 27.166L417.64 32.2038C415.303 32.3111 413.006 32.6125 410.77 33.1149L408.866 28.4152C408.347 27.134 406.879 26.5243 405.589 27.0564L397.511 30.3837C396.219 30.9158 395.589 32.391 396.105 33.6744L398.018 38.4336C396.061 39.6805 394.211 41.0918 392.49 42.6538L388.434 39.5069C387.338 38.6574 385.748 38.8675 384.883 39.9773L379.457 46.9197C378.587 48.0318 378.772 49.6258 379.868 50.4776L383.94 53.6428C382.855 55.6798 381.944 57.831 381.208 60.0758L376.04 59.3976C374.652 59.2149 373.359 60.1991 373.154 61.5967L371.854 70.3523C371.647 71.7544 372.606 73.0424 373.997 73.2251L379.18 73.9057C379.242 76.2692 379.5 78.594 379.959 80.8571L375.095 82.885C373.784 83.4308 373.14 84.9403 373.656 86.2534L376.897 94.4883C377.415 95.8082 378.902 96.4317 380.217 95.8813L385.084 93.8443C386.308 95.8356 387.703 97.7128 389.251 99.4575L386.009 103.669C385.132 104.808 385.319 106.439 386.429 107.311L393.38 112.764C394.492 113.637 396.107 113.418 396.982 112.273L400.185 108.09C402.232 109.179 404.397 110.086 406.655 110.81L405.927 116.03C405.728 117.46 406.703 118.768 408.105 118.951L416.881 120.102C418.286 120.287 419.581 119.275 419.777 117.846L420.485 112.664C422.871 112.561 425.217 112.253 427.498 111.739L429.423 116.526C429.958 117.855 431.453 118.483 432.764 117.928L440.949 114.459C442.257 113.904 442.881 112.381 442.344 111.056L440.419 106.304C442.417 105.014 444.299 103.55 446.044 101.931L450.045 105.041C451.164 105.911 452.767 105.692 453.625 104.552L458.985 97.4456C459.842 96.3106 459.629 94.6915 458.512 93.826L454.548 90.7522C455.628 88.6581 456.526 86.4452 457.238 84.141L462.194 84.7919C463.584 84.9745 464.859 83.9812 465.039 82.5744L466.165 73.796C466.345 72.3962 465.366 71.1127 463.977 70.93L459.035 70.2815C458.933 67.8882 458.631 65.5406 458.124 63.2592L462.708 61.341C463.996 60.802 464.605 59.3131 464.071 58.0159L460.723 49.9227C460.189 48.6301 458.713 48.0181 457.425 48.5548L452.815 50.4776C451.559 48.5068 450.138 46.6479 448.56 44.9283L451.607 40.9525C452.454 39.8449 452.246 38.2623 451.145 37.4151L444.26 32.1238C443.159 31.2789 441.581 31.4867 440.732 32.5897L437.667 36.5701C435.635 35.5151 433.488 34.6381 431.248 33.9439L431.931 28.945C432.118 27.5702 431.157 26.3073 429.779 26.1269L421.177 24.9988C419.807 24.823 418.535 25.789 418.343 27.166ZM388.014 67.9727C390.501 50.6717 406.379 38.5432 423.495 40.788C440.611 43.0329 452.632 58.8221 450.332 76.1459C448.019 93.5771 432.106 105.943 414.803 103.675C397.5 101.405 385.513 85.3788 388.014 67.9727Z",
    fill: "#D8DEE8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M286.435 24.4344L285.348 32.224C281.737 32.3884 278.184 32.8543 274.726 33.6307L271.783 26.3641C270.979 24.3819 268.711 23.441 266.718 24.2631L254.228 29.4082C252.23 30.2326 251.255 32.5094 252.054 34.4985L255.014 41.8564C251.988 43.7838 249.127 45.9647 246.466 48.3831L240.186 43.5167C238.494 42.2036 236.034 42.5301 234.696 44.2429L226.306 54.9761C224.961 56.6957 225.246 59.1597 226.941 60.4774L233.237 65.3736C231.561 68.5227 230.149 71.85 229.012 75.3189L221.022 74.2707C218.877 73.9898 216.879 75.5107 216.557 77.6711L214.55 91.2109C214.228 93.3803 215.712 95.3694 217.863 95.6503L225.877 96.7008C225.973 100.355 226.37 103.951 227.082 107.45L219.562 110.585C217.534 111.43 216.539 113.762 217.338 115.794L222.348 128.526C223.15 130.565 225.45 131.531 227.482 130.679L235.007 127.53C236.898 130.609 239.056 133.511 241.451 136.208L236.439 142.719C235.082 144.482 235.372 147.003 237.089 148.35L247.839 156.782C249.558 158.131 252.054 157.791 253.408 156.023L258.362 149.556C261.525 151.241 264.875 152.644 268.366 153.763L267.238 161.835C266.93 164.046 268.437 166.069 270.609 166.352L284.179 168.131C286.348 168.417 288.353 166.852 288.654 164.642L289.751 156.631C293.441 156.473 297.067 155.996 300.593 155.201L303.569 162.603C304.396 164.658 306.709 165.628 308.735 164.77L321.391 159.408C323.412 158.551 324.378 156.195 323.547 154.144L320.569 146.795C323.658 144.802 326.568 142.536 329.267 140.033L335.451 144.843C337.18 146.188 339.658 145.847 340.987 144.089L349.274 133.102C350.596 131.348 350.27 128.843 348.543 127.505L342.414 122.755C344.086 119.515 345.472 116.094 346.573 112.533L354.237 113.538C356.388 113.821 358.359 112.284 358.637 110.11L360.377 96.5364C360.656 94.3692 359.14 92.387 356.995 92.1061L349.354 91.1035C349.197 87.404 348.731 83.773 347.945 80.247L355.034 77.2805C357.027 76.447 357.97 74.1451 357.139 72.14L351.962 59.6256C351.135 57.6274 348.854 56.682 346.865 57.5109L339.738 60.482C337.797 57.4333 335.597 54.5604 333.161 51.9045L337.87 45.7569C339.18 44.0465 338.861 41.5984 337.155 40.2876L326.508 32.1075C324.807 30.8012 322.366 31.1232 321.053 32.8291L316.312 38.9836C313.167 37.3531 309.849 35.9966 306.387 34.921L307.444 27.1908C307.734 25.0647 306.245 23.1144 304.119 22.8358L290.817 21.0911C288.696 20.8125 286.732 22.3083 286.435 24.4344ZM239.54 87.5296C243.383 60.7788 267.935 42.0254 294.398 45.4966C320.861 48.9677 339.448 73.3801 335.894 100.167C332.318 127.117 307.716 146.24 280.963 142.73C254.208 139.223 235.671 114.44 239.54 87.5296Z",
    fill: "#D8DEE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.707 99.8636L215.529 583.438C214.656 590.688 219.653 597.187 226.655 597.882L468.978 624.486C483.822 625.409 491.949 617.825 492.868 610.115L553.949 95.9951C554.86 88.3289 547.577 81.3843 532.669 81.3843L288.142 86.5339C281.06 86.655 274.575 92.6518 273.707 99.8636Z",
    fill: "url(#paint4_linear_2_2610)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M262.801 99.0327L204.303 585.025C203.426 592.312 208.441 598.846 215.465 599.545L466.686 624.557C474.562 625.341 481.781 619.643 482.701 611.895L544.125 95.1185C545.041 87.4112 539.256 81.2179 531.293 81.3526L277.286 85.6391C270.184 85.7555 263.673 91.7844 262.801 99.0327Z",
    fill: "url(#paint5_linear_2_2610)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M267.57 125.838L213.349 576.45C212.529 583.257 217.226 589.35 223.801 589.989L460.066 612.956C467.388 613.669 474.097 608.35 474.956 601.136L531.72 123.755C532.575 116.58 527.203 110.773 519.807 110.853L281.116 113.394C274.473 113.463 268.385 119.065 267.57 125.838Z",
    fill: "#D8DEE8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M394.266 98.6967C393.956 101.284 395.812 103.355 398.416 103.321C401.021 103.289 403.387 101.161 403.698 98.5688C404.008 95.9768 402.145 93.9056 399.539 93.9444C396.934 93.9832 394.575 96.1116 394.266 98.6967Z",
    fill: "url(#paint6_linear_2_2610)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M308.416 428.318C356.784 338.892 429.041 312.123 450.796 219.959C462.554 170.141 454.543 122.458 441.049 82.8735L531.297 81.3503C539.26 81.2156 545.044 87.4111 544.129 95.1162L482.705 611.892C481.785 619.643 474.566 625.341 466.69 624.555L269.206 604.893C267.742 524.764 286.854 468.179 308.416 428.318Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.291 150.317C24.291 102.799 65.7417 64.285 115.484 64.2896C163.756 64.2941 201.852 100.782 201.852 145.786C201.852 190.791 163.756 229.222 115.484 231.691C65.7394 234.235 24.291 197.836 24.291 150.317Z",
    fill: "url(#paint7_linear_2_2610)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6523 146.528C29.6523 99.0098 69.9041 60.4959 118.206 60.5005C165.08 60.5051 202.075 96.9934 202.075 141.997C202.075 187.002 165.08 225.433 118.206 227.902C69.9018 230.446 29.6523 194.044 29.6523 146.528Z",
    fill: "url(#paint8_linear_2_2610)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.4336 146.165C43.4336 106.242 77.25 73.8826 117.833 73.8894C157.215 73.894 188.297 104.55 188.297 142.36C188.297 180.171 157.217 212.46 117.833 214.533C77.25 216.671 43.4336 186.088 43.4336 146.165Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M115.038 80.0233C154.42 80.0279 185.503 110.684 185.503 148.494C185.503 157.485 183.729 166.156 180.52 174.19C185.489 164.516 188.298 153.69 188.298 142.36C188.298 104.55 157.218 73.894 117.834 73.8894C86.5338 73.8871 59.2761 93.1429 48.4355 120.264C60.7102 96.42 86.1547 80.021 115.038 80.0233Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1836 136.394V171.238C84.1836 181.311 92.6583 189.258 103.081 188.986L128.925 188.313C139.222 188.043 147.544 179.747 147.544 169.778V135.302L84.1836 136.394ZM107.984 172.416L112.786 157.862C110.729 156.8 109.336 154.709 109.336 152.272C109.336 148.696 112.337 145.738 116.032 145.67C119.722 145.599 122.711 148.435 122.711 152.005C122.711 154.437 121.323 156.581 119.272 157.728L124.056 172.042L107.984 172.416Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.198 132.281C137.455 132.326 135.231 130.205 135.231 127.54C135.231 117.298 126.633 109.076 116.03 109.213C105.39 109.35 96.7057 117.848 96.7057 128.154C96.7057 130.835 94.4518 133.046 91.668 133.094C88.8819 133.139 86.6211 131.002 86.6211 128.316C86.6211 112.63 99.8503 99.718 116.032 99.5376C132.128 99.3572 145.156 111.849 145.156 127.385C145.156 130.043 142.938 132.235 140.198 132.281Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M200.056 331.02C200.056 331.02 198.298 324.43 199.544 322.744C200.789 321.059 208.405 314.322 207.674 316.519C206.941 318.716 205.843 320.18 205.843 320.18C205.843 320.18 209.944 322.084 207.307 324.939C204.671 327.796 203.79 328.453 203.644 331.018C203.5 333.582 201.814 334.462 200.056 331.02Z",
    fill: "url(#paint9_linear_2_2610)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.9 615.511C126.9 615.511 125.968 621.211 126.087 623.239C126.205 625.267 148.718 626.304 148.944 624.785C149.17 623.267 145.224 620.848 142.444 619.997C139.665 619.142 131.531 616.868 131.531 616.868L126.9 615.511Z",
    fill: "url(#paint10_linear_2_2610)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M132.364 609.83L131.646 616.918C131.646 616.918 129.032 618.647 126.727 617.313L125.574 609.599L132.364 609.83Z",
    fill: "url(#paint11_linear_2_2610)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7336 624.751C86.7336 624.751 85.8019 630.451 85.9206 632.479C86.0394 634.507 108.552 635.544 108.778 634.025C109.006 632.507 105.058 630.088 102.278 629.237C99.4992 628.385 91.3649 626.108 91.3649 626.108L86.7336 624.751Z",
    fill: "url(#paint12_linear_2_2610)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1975 619.069L91.4805 626.158C91.4805 626.158 88.8657 627.887 86.5615 626.553L85.4082 618.839L92.1975 619.069Z",
    fill: "url(#paint13_linear_2_2610)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.28 424.794C130.881 430.069 133.485 435.345 136.086 440.62C138.177 470.725 139.219 503.464 138.55 538.475C138.052 564.522 136.661 589.197 134.661 612.358C131.132 612.196 127.604 612.034 124.076 611.871C118.974 601.746 112.952 586.406 112.397 567.47C111.819 547.719 117.807 545.095 117.428 526.184C116.935 501.671 106.656 495.131 101.18 465.646C99.0858 454.37 97.6768 439.642 99.3507 421.775C108.995 422.782 118.636 423.789 128.28 424.794Z",
    fill: "url(#paint14_linear_2_2610)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M99.3517 421.775C104.558 422.319 109.765 422.862 114.974 423.406C124.349 439.718 126.966 456.694 125.319 464.205C122.992 474.831 116.835 478.234 117.176 488.901C117.511 499.456 123.73 502.194 127.674 514.633C130.405 523.247 129.683 531.167 128.13 546.655C125.002 577.852 117.468 587.393 123.778 597.621C125.57 600.528 128.802 603.988 135.132 606.63C134.977 608.544 134.824 610.462 134.662 612.355C131.133 612.196 127.605 612.031 124.077 611.871C118.975 601.746 112.953 586.406 112.398 567.47C111.821 547.719 117.808 545.095 117.429 526.184C116.936 501.671 106.657 495.133 101.181 465.649C99.0868 454.372 97.6755 439.645 99.3517 421.775Z",
    fill: "url(#paint15_linear_2_2610)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M114.277 434.292C109.392 460.928 105.078 489.435 101.712 519.669C97.6473 556.173 95.4778 590.588 94.626 622.538C90.7529 622.648 86.8821 622.757 83.0091 622.867C67.7496 592.679 66.8179 572.213 69.0171 558.888C69.8643 553.754 72.1685 543.686 72.6938 528.637C73.0592 518.148 72.39 510.164 71.5542 500.568C69.7227 479.529 67.4984 474.936 67.1787 458.843C66.8773 443.739 66.8156 436.098 71.1272 431.638C82.4861 419.884 112.037 433.25 114.277 434.292Z",
    fill: "url(#paint16_linear_2_2610)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M198.032 330.004C200.608 329.824 203.181 329.646 205.757 329.465C211.832 354.017 207.475 377.831 193.764 386.589C172.341 400.272 132.525 374.492 123.897 346.419C120.111 334.097 120.972 316.316 128.542 312.861C130.643 311.902 133.904 311.753 140.968 315.718C162.062 327.561 162.617 349.945 173.341 351.841C178.105 352.686 185.805 349.646 198.032 330.004Z",
    fill: "url(#paint17_linear_2_2610)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.05 446.021C142.761 439.864 138.1 433.926 137.04 422.264C135.839 409.044 140.932 406.842 145.967 384.935C149.317 370.365 152.53 356.378 148.694 340.004C146.855 332.157 143.736 318.848 132.72 312.42C127.035 309.102 119.273 309.435 103.984 310.234C85.0755 311.223 75.6235 311.716 68.5715 315.43C67.5393 315.973 46.0912 327.64 44.6137 346.659C43.111 366.015 64.1892 368.616 67.0004 394.428C68.2632 406.016 66.0138 423.837 64.5546 435.395C63.1547 446.493 62.1887 449.334 64.381 452.696C69.6608 460.796 85.8223 458.487 118.145 453.872C130.824 452.059 136.28 450.615 139.05 446.021Z",
    fill: "url(#paint18_linear_2_2610)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8669 390.274C88.499 395.305 83.5845 399.062 80.1636 411.3C79.426 413.942 74.1622 432.757 80.988 437.389C84.9296 440.063 88.4693 434.995 98.0378 434.333C114.617 433.187 122.516 447.121 133.348 443.315C135.227 442.652 137.707 441.246 140.185 438.012C140.678 440.926 140.594 443.459 139.05 446.023C136.282 450.618 130.824 452.061 118.145 453.872C85.8225 458.487 69.6611 460.796 64.3813 452.696C62.1912 449.337 63.1549 446.494 64.5548 435.395C66.0141 423.835 68.2635 406.013 67.0006 394.428C64.1894 368.616 43.109 366.015 44.6139 346.659C45.0158 341.484 46.9181 336.878 49.4644 332.865C76.2038 343.685 94.1625 374.465 89.8669 390.274Z",
    fill: "url(#paint19_linear_2_2610)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0957 428.347L61.4463 431.764C62.4077 430.654 64.632 428.416 68.1032 427.653C72.0151 426.792 76.507 428.028 76.6098 429.274C76.6943 430.275 73.9585 431.284 73.536 431.439C70.1219 432.7 67.5894 431.652 66.21 433.024C65.7213 433.508 65.1139 434.413 63.714 435.248C63.3463 435.468 62.9627 435.662 62.7594 435.742C60.4803 436.628 56.573 432.661 56.2373 432.314L56.0957 428.347Z",
    fill: "url(#paint20_linear_2_2610)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9006 358.179C75.7714 348.91 78.4524 334.717 72.339 313.641C32.0598 329.513 11.5183 367.138 19.5385 396.963C26.1497 421.551 50.2058 433.527 55.5724 436.048C56.8216 433.205 58.0707 430.364 59.3176 427.523C53.0992 420.599 46.0907 410.359 47.0818 398.673C48.4565 382.473 64.0653 376.944 71.9006 358.179Z",
    fill: "url(#paint21_linear_2_2610)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M102.992 291.165C102.992 291.165 102.674 298.211 100.486 303.488C98.5088 308.256 88.1135 311.255 86.0057 312.319C83.8979 313.383 89.9542 316.496 96.0356 317.106C102.117 317.718 119.482 316.336 122.613 314.032C125.744 311.728 120.096 311.901 115.757 310.307C111.416 308.713 108.906 300.225 109.674 296.372C110.441 292.517 102.992 291.165 102.992 291.165Z",
    fill: "url(#paint22_linear_2_2610)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M112.611 288.61C115.767 285.509 116.208 285.148 116.551 284.077C117.93 279.777 114.594 273.885 110.218 272.435C109.99 272.36 107.055 271.421 105.936 272.693C104.984 273.773 106.384 275.267 105.719 277.352C105.096 279.302 103.406 279.448 100.27 282.006C97.6876 284.111 96.0845 285.422 95.7145 287.265C94.9518 291.063 99.5488 296.567 103.618 296.418C105.082 296.363 105.482 295.617 112.611 288.61Z",
    fill: "url(#paint23_linear_2_2610)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M104.019 297.005C104.019 297.005 107.373 300.803 112.482 299.547C117.056 298.423 115.889 287.923 112.541 286.247C111.424 285.687 109.394 285.733 107.869 286.468C106.967 286.902 106.716 287.354 105.229 288.035C103.859 288.663 103.423 288.576 103.055 289.019C102.594 289.572 102.395 290.764 103.84 293.637C102.799 292.899 101.678 292.744 100.99 293.232C100.881 293.31 100.602 293.584 100.481 293.943C100.045 295.242 101.397 296.564 104.019 297.005Z",
    fill: "url(#paint24_linear_2_2610)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M486.589 154.836L487.77 161.209L463.465 161.266L252.546 161.767C247.12 161.78 242.13 166.265 241.386 171.785L191.036 508.289C190.287 513.859 198.955 522.361 204.349 522.776L297.922 529.968V529.854L437.892 540.591C437.895 540.591 437.897 540.591 437.899 540.591L438.237 540.733C444.214 541.194 449.697 536.858 450.473 530.975C450.473 530.973 450.473 531 450.475 530.998L497.628 171.721C498.396 165.893 492.6 154.82 486.589 154.836Z",
    fill: "url(#paint25_linear_2_2610)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M445.704 523.974C444.932 529.859 439.452 534.257 433.475 533.798L199.345 515.821C193.954 515.408 190.202 510.557 190.951 504.987L236.722 164.905C237.464 159.385 242.454 154.9 247.875 154.884L483.327 154.236C489.336 154.22 493.597 158.931 492.834 164.759L445.704 523.974Z",
    fill: "url(#paint26_linear_2_2610)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M448.815 336.948C448.432 339.862 445.71 342.036 442.736 341.926L236.675 334.406C233.955 334.308 232.041 332.067 232.416 329.284L236.467 299.256C236.842 296.474 239.324 294.593 242.046 294.668L448.288 300.395C451.266 300.478 453.374 302.581 452.992 305.492L448.815 336.948Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M440.835 397.96C440.451 400.881 437.727 403.373 434.754 403.224L228.848 393.053C226.13 392.918 224.239 390.317 224.614 387.531L228.697 356.923C229.071 354.139 231.577 351.753 234.296 351.863L440.328 360.173C443.301 360.294 445.405 362.984 445.021 365.9L440.835 397.96Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M453.008 305.372C452.519 305.214 451.994 305.127 451.434 305.111L245.188 299.386C242.468 299.309 239.984 301.195 239.614 303.969L235.556 333.997C235.546 334.075 235.54 334.148 235.533 334.226C233.441 333.637 232.096 331.654 232.411 329.279L236.469 299.251C236.839 296.477 239.324 294.588 242.043 294.668L448.29 300.393C451.215 300.48 453.314 302.517 453.008 305.372Z",
    fill: "url(#paint27_linear_2_2610)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M445.066 365.224C444.571 365.028 444.036 364.909 443.47 364.886L237.443 356.573C234.723 356.464 232.213 358.855 231.843 361.639L227.753 392.249C227.73 392.445 227.714 392.635 227.714 392.831C225.623 392.155 224.293 389.906 224.609 387.531L228.699 356.921C229.069 354.137 231.576 351.746 234.298 351.855L440.325 360.168C443.077 360.287 445.073 362.582 445.066 365.224Z",
    fill: "url(#paint28_linear_2_2610)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M386.073 447.414C386.681 442.807 383.424 438.564 378.795 438.297L272.205 432.177C267.791 431.923 263.715 435.641 263.114 440.126L258.716 473.281C258.115 477.773 261.178 482.07 265.59 482.372L372.125 489.661C376.751 489.979 381.013 486.071 381.622 481.458L386.073 447.414Z",
    fill: "url(#paint29_linear_2_2610)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M394.123 224.042C392.719 234.64 387.274 244.206 379.533 251.242C371.191 258.831 360.202 263.448 348.774 263.227C337.404 263.008 327.833 258.041 321.688 250.283C316.02 243.133 313.243 233.605 314.634 223.185C317.527 201.506 337.445 183.982 359.302 184.034C381.367 184.082 397.042 201.993 394.123 224.042Z",
    fill: "url(#paint30_linear_2_2610)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M372.869 211.995C371.609 221.491 362.844 229.1 353.328 228.986C343.851 228.872 337.215 221.137 338.468 211.71C339.724 202.285 348.4 194.683 357.882 194.726C367.405 194.77 374.13 202.5 372.869 211.995Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M379.535 251.243C371.192 258.831 360.203 263.449 348.776 263.227C337.406 263.008 327.835 258.041 321.689 250.283C328.723 240.484 340.324 233.967 352.644 234.127C365.031 234.286 375.015 241.151 379.535 251.243Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M492.833 164.758L445.705 523.973C444.933 529.855 439.103 534.229 433.129 533.77L292.508 522.972C285.828 516.133 280.327 507.925 276.401 498.076C274.474 493.246 273.063 488.035 272.124 482.554C269.514 467.386 270.525 450.144 274.332 433.22C277.26 420.192 281.85 407.33 287.726 395.725C292.426 386.446 297.952 377.962 304.125 370.833C308.569 365.701 313.376 360.716 318.446 355.827C324.559 349.926 331.056 344.166 337.759 338.46C353.377 325.153 370.1 312.143 385.583 298.404C421.309 266.712 450.293 231.299 443.318 180.771C443.095 179.179 440.918 166.991 438.137 154.358L482.979 154.235C488.985 154.219 493.598 158.932 492.833 164.758Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2_2610",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(311.401 319.713) rotate(90) scale(319.713 311.401)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE6E57",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE6E57",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_2610",
    x1: 311.401,
    y1: 0.00000633836,
    x2: 378.636,
    y2: 652.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_2610",
    x1: 428.188,
    y1: 461.211,
    x2: 594.984,
    y2: 10.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBBBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_2610",
    x1: 304.712,
    y1: 416.739,
    x2: 628.243,
    y2: 416.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF8976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_2610",
    x1: 387.736,
    y1: 340.467,
    x2: 483.234,
    y2: 350.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_2610",
    x1: 303.594,
    y1: 99.7458,
    x2: 539.733,
    y2: 903.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_2610",
    x1: 392.081,
    y1: 79.9443,
    x2: 669.608,
    y2: 831.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_2610",
    x1: -2032.59,
    y1: 2171.28,
    x2: -1842.76,
    y2: 1992.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_2610",
    x1: 58.1692,
    y1: 196.561,
    x2: 210.286,
    y2: 58.5185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_2610",
    x1: 212.291,
    y1: 316.593,
    x2: 182.147,
    y2: 347.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_2610",
    x1: 137.573,
    y1: 608.041,
    x2: 137.827,
    y2: 539.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_2610",
    x1: 130.831,
    y1: 629.915,
    x2: 127.59,
    y2: 594.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_2610",
    x1: 97.4436,
    y1: 607.892,
    x2: 97.6976,
    y2: 539.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_2610",
    x1: 90.1584,
    y1: 633.661,
    x2: 86.9172,
    y2: 598.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_2610",
    x1: 129.601,
    y1: 452.686,
    x2: 104.651,
    y2: 580.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_2610",
    x1: 142.051,
    y1: 515.06,
    x2: 104.566,
    y2: 518.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_2610",
    x1: 121.317,
    y1: 522.11,
    x2: 64.4124,
    y2: 526.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_2610",
    x1: 166.266,
    y1: 334.292,
    x2: 124.165,
    y2: 604.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_2610",
    x1: 76.7255,
    y1: 631.073,
    x2: 56.363,
    y2: 903.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_2610",
    x1: 7.49461,
    y1: 538.031,
    x2: 119.878,
    y2: 345.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_2610",
    x1: 47.3347,
    y1: 404.93,
    x2: 71.0372,
    y2: 436.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_2610",
    x1: 26.9749,
    y1: 627.361,
    x2: 6.61239,
    y2: 900.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_2610",
    x1: 114.644,
    y1: 325.143,
    x2: 91.8258,
    y2: 296.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2_2610",
    x1: 97.2944,
    y1: 314.715,
    x2: 109.388,
    y2: 274.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3E4177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2_2610",
    x1: 128.138,
    y1: 300.832,
    x2: 94.1201,
    y2: 285.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2_2610",
    x1: 190.991,
    y1: 347.802,
    x2: 497.698,
    y2: 347.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2_2610",
    x1: 377.459,
    y1: 951.04,
    x2: 340.888,
    y2: 317.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2_2610",
    x1: 232.364,
    y1: 314.448,
    x2: 453.036,
    y2: 314.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2_2610",
    x1: 224.565,
    y1: 372.342,
    x2: 445.066,
    y2: 372.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2_2610",
    x1: 332.945,
    y1: 393.719,
    x2: 283.653,
    y2: 706.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2_2610",
    x1: 349.159,
    y1: 68.2622,
    x2: 359.686,
    y2: 381.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003597,
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC444"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/signIn.e6ab749ecd69334816486665196819a0.svg";
export { ForwardRef as ReactComponent };